import { MotionConfig } from 'framer-motion'
import React, { useState } from 'react'
import RenovationCardList from '../organisms/RenovationCardList'
import RenovationElevator from '../organisms/RenovationElevator'

const M14Renovation = ({
  heading,
  bodyText,
  liftImage,
  revonationCards,
  anchorLinkId,
}) => {
  const [openCardId, setOpenCardId] = useState(null)
  const overlayUrl = openCardId
    ? revonationCards.find(({ id }) => id === openCardId)?.liftOverlay[0]?.url
    : null

  return (
    <MotionConfig transition={{ duration: 0.5, type: 'tween' }}>
      <section className="my-10 md:my-20" id={anchorLinkId}>
        <div className="container">
          <div className="row-type-k">
            <div className="col-1-type-k">
              <h2 className="mb-6 u-h0 lg:w-10/12">{heading}</h2>
              <div className="mb-20 column-indent lg:w-10/12">
                <p
                  className="u-p"
                  dangerouslySetInnerHTML={{ __html: bodyText }}
                />
              </div>

              <div className="flex justify-end">
                <div className="hidden w-11/12 grid-cols-2 gap-16 pl-5 lg:grid xl:gap-x-20 gap-y-10 md:gap-y-12 lg:gap-y-14">
                  <RenovationCardList
                    cards={revonationCards}
                    openCardId={openCardId}
                    onToggleCard={id =>
                      setOpenCardId(id === openCardId ? null : id)
                    }
                  />
                </div>
              </div>
            </div>

            <div className="relative hidden lg:block col-2-type-k">
              <RenovationElevator
                url={liftImage[0]?.url}
                overlayUrl={overlayUrl}
              />
            </div>
          </div>

          <div className="row-type-k lg:hidden">
            <div className="col-3-type-k">
              <RenovationCardList
                cards={revonationCards}
                openCardId={openCardId}
                onToggleCard={id =>
                  setOpenCardId(id === openCardId ? null : id)
                }
              />
            </div>
            <div className="relative col-2-type-k">
              <RenovationElevator
                url={liftImage[0]?.url}
                overlayUrl={overlayUrl}
              />
            </div>
          </div>
        </div>
      </section>
    </MotionConfig>
  )
}

export default M14Renovation
